import { List, fromJS } from 'immutable'
import { RxConversationAPI, RxEmailApi } from '@driftt/dapper'
import { Inbox, SendingDomain } from './models'

export const api = {
  fetchInbox(id) {
    return RxConversationAPI.get(`/inboxes/${id}`)
      .checkStatus()
      .retryWithBackoff()
      .map(({ response }) => Inbox(response))
  },
  patchInbox({id, name, address }) {
    return RxConversationAPI.patch(`/inboxes/${id}`, {
      name,
      address
    })
    .checkStatus()
    .retryWithBackoff()
    .map(({ response }) => Inbox(response))
  },
  fetchInboxList() {
    return RxConversationAPI.get('/inboxes')
      .checkStatus()
      .retryWithBackoff()
      .map(({ response }) => List(response).map(data => Inbox(data)))
  },
  bulkCloseForInbox(inboxId) {
    return RxConversationAPI.post(`/bulk_close/bulk_close_inbox_admin?inboxId=${inboxId}`).checkStatus()
  },
  fetchCounts(id) {
    return RxConversationAPI.get(`/inboxes/${id}/conversations/counts`)
      .checkStatus()
      .retryWithBackoff(3, (count) => Math.pow(2, count) * 1000, [403, 404])
      .mapResponse(fromJS)
  },
  fetchCounts2(id) {
    return RxConversationAPI.get(`/inboxes/${id}/conversations/counts/v2`)
      .checkStatus()
      .retryWithBackoff(3, (count) => Math.pow(2, count) * 1000, [403, 404])
      .mapResponse(fromJS)
  },
  fetchSendingDomains() {
    return RxEmailApi.get('/sending_domains')
      .checkStatus()
      .retryWithBackoff()
      .map(({ response }) => List(response).map(data => SendingDomain(data)))
  },
  verifySendingDomain(id) {
    return RxEmailApi.get(`/sending_domains/${id}/verify`)
      .checkStatus()
      .map(({ response }) => SendingDomain(response))
  },
  deleteSendingDomain(id) {
    return RxEmailApi.delete(`/sending_domains/${id}`)
      .checkStatus()
      .mapResponse(fromJS)
  },
  createSendingDomain(domain) {
    return RxEmailApi.post(`/sending_domains/`, { domain })
      .checkStatus()
      .map(({ response }) => SendingDomain(response))
  },
  fetchWhitelabel(domain) {
    return RxConversationAPI.get(`/whitelabels/${domain}`)
      .checkStatus()
      .mapResponse(fromJS)
  },
  verifyWhitelabel(domain) {
    return RxConversationAPI.post(`/whitelabels/${domain}/validate`)
      .checkStatus()
      .mapResponse(fromJS)
  },
  createWhitelabel(domain) {
    return RxConversationAPI.post(`/whitelabels/${domain}`)
      .checkStatus()
      .mapResponse(fromJS)
  },
  createInbox(params) {
    return RxConversationAPI.post(`/inboxes`, params)
      .checkStatus()
      .retryWithBackoff()
      .mapResponse(fromJS)
  },
  archiveInbox({ id }) {
    return RxConversationAPI.patch(`/inboxes/${id}`, {
      status: 'ARCHIVED'
    })
      .checkStatus()
      .retryWithBackoff()
      .mapResponse(fromJS)
  },
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/inbox/api.js